import { render, staticRenderFns } from "./sync-detail.vue?vue&type=template&id=7242f4a8&scoped=true&"
import script from "./sync-detail.vue?vue&type=script&lang=ts&"
export * from "./sync-detail.vue?vue&type=script&lang=ts&"
import style0 from "./sync-detail.vue?vue&type=style&index=0&id=7242f4a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7242f4a8",
  null
  
)

export default component.exports